export default __webpack_public_path__ + "static/media/leftArrow.69b33f37.svg";